import { useEffect, useRef, useCallback } from 'react';
import config from '@src/config';

export default function useSessionTimeout(onTimeout) {
  const timeoutRef = useRef();

  const resetTimer = useCallback(() => {
    clearTimeout(timeoutRef.current);
    const { inactivityLimit } = config;
    timeoutRef.current = setTimeout(onTimeout, inactivityLimit);
  }, [onTimeout]);

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  useEffect(() => {
    const events = ['mousemove', 'keydown', 'scroll', 'click', 'touchstart'];

    const handleVisibilityChange = () => {
      if (!document.hidden) {
        resetTimer();
      }
    };

    events.forEach(event =>
      window.addEventListener(event, resetTimer, { passive: true })
    );
    document.addEventListener('visibilitychange', handleVisibilityChange);

    resetTimer();

    return () => {
      clearTimeout(timeoutRef.current);
      events.forEach(event =>
        window.removeEventListener(event, resetTimer, { passive: true })
      );
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [resetTimer]);
}



// WEBPACK FOOTER //
// ./src/hooks/useSessionTimeout.js